/**
 * Created by Andrey Popov on 06.08.26
 */

const GameAnnounceWindow = Prefab.createWindow(
    "game_announce_window",
    "gameannouncewindow_prefab_json",
    {
        bundles: () => [GameAnnounce.getBundleName()]
    }
);
